import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriversGridComponent } from './drivers-grid.component';
import {TabModule} from '../../tab/tab.module';
import {DxDataGridModule, DxPopupModule} from 'devextreme-angular';
import {GridDefaultModule, GridTitleModule, ProfilePhotoUploadModule, TagsViewerModule} from 'shared';
import {UserDomainsChooserModule} from '../../user-domains/user-domains-chooser/user-domains-chooser.module';
import {IconModule} from '@visurel/iconify-angular';



@NgModule({
  declarations: [DriversGridComponent],
  imports: [
    CommonModule,
    TabModule,
    DxDataGridModule,
    GridDefaultModule,
    GridTitleModule,
    ProfilePhotoUploadModule,
    UserDomainsChooserModule,
    IconModule,
    DxPopupModule,
    TagsViewerModule
  ],
  exports: [DriversGridComponent]
})
export class DriversGridModule { }
